import React from 'react';
import PropTypes from 'prop-types';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import { withStyles } from '@material-ui/core/styles';
import { slugify } from 'bento-ordering/utils/slugify';

import MenuSectionBarNavItem from 'bento-ordering/menus/components/MenuSectionBarNavItem';
import MenuSectionBarMoreButton from 'bento-ordering/menus/components/MenuSectionBarMoreButton';

const styles = theme => ({
  paper: {
    paddingTop: '1.25rem',
    paddingBottom: '.25rem',
    paddingLeft: '.5rem',
    boxShadow:
      'rgba(0, 0, 0, 0.08) 0px 3px 10px 0px, rgba(0, 0, 0, 0.01) 0px 1px 0px 0px, rgba(0, 0, 0, 0.01) 0px 0px 5px 0px',
    borderRadius: '8px'
  }
});

class MenuSectionBarDropDown extends React.Component {
  static propTypes = {
    handleSetActive: PropTypes.func,
    menuSections: PropTypes.array,
    activeMenuSectionName: PropTypes.string,
    offset: PropTypes.number,
    classes: PropTypes.shape({}).isRequired
  };

  state = {
    anchorElement: null
  };

  openDropDown = event => {
    this.setState({
      anchorElement: event.currentTarget
    });
  };

  closeDropDown = () => {
    this.setState({ anchorElement: null });
  };

  /**
   * Handles the clicking of a section item. First closeDropDown is called
   * which is responsible for closing the dropdown. Next handleSetActive
   * is called. A callback argument 'to' is passed to the handleSetActive
   * method to set the current handle item.
   *
   * @param {} to callback string section name argument passed in from MenuSectionBarNavItem
   */
  handleSectionItemClick = to => {
    const { handleSetActive } = this.props;
    this.closeDropDown();
    handleSetActive(to);
  };

  isDropDownSectionSelected = () => {
    const { menuSections, activeMenuSectionName } = this.props;
    const isDropselectedSelected = menuSections.find(
      sectionItem => slugify(sectionItem.name) === activeMenuSectionName
    );

    return Boolean(isDropselectedSelected);
  };

  render() {
    const { menuSections, activeMenuSectionName, offset, classes } = this.props;
    const isMoreButtonHighlighted = this.isDropDownSectionSelected();

    return (
      <React.Fragment>
        <MenuSectionBarMoreButton
          isHighlighted={isMoreButtonHighlighted}
          onClick={this.openDropDown}
          isExpanded={Boolean(this.state.anchorElement)}
        />
        <Menu
          classes={classes}
          id="menu-section-more-dropdown"
          data-testid="menu-section-more-dropdown"
          anchorEl={this.state.anchorElement}
          keepMounted
          open={Boolean(this.state.anchorElement)}
          onClose={this.closeDropDown}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          {menuSections.map(section => (
            <MenuItem
              style={{
                paddingBottom: '8px',
                color: 'green'
              }}
              key={`${section.id}`}
              onClick={this.closeDropDown}
              component={MenuSectionBarNavItem}
              menuSection={section}
              handleSetActive={this.handleSectionItemClick}
              activeMenuSectionName={activeMenuSectionName}
              justifyContent={'left'}
              offset={offset}
              hasBottomPadding={false}
              hasTopPadding={false}
              isInMoreSection={true}
            />
          ))}
        </Menu>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(MenuSectionBarDropDown);
